/* ============================================
   KARA LUXE - Theme JavaScript
   ============================================ */

(function() {
  'use strict';

  /* --- Header / Sticky --- */
  const header = document.querySelector('[data-header]');
  if (header && header.classList.contains('header--sticky')) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      lastScroll = scrollY;
    }, { passive: true });
  }

  /* --- Mobile Menu --- */
  const mobileToggle = document.getElementById('mobileMenuToggle');
  const mobileNav = document.getElementById('mobileNav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('active');
      mobileToggle.classList.toggle('active');
    });

    // Sub-menu toggles
    mobileNav.querySelectorAll('.mobile-nav__toggle').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const sublist = btn.nextElementSibling;
        if (sublist) sublist.classList.toggle('active');
        btn.classList.toggle('active');
      });
    });
  }

  /* --- Cart Drawer --- */
  const cartToggle = document.getElementById('cartToggle');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartDrawerClose = document.getElementById('cartDrawerClose');
  const overlay = document.getElementById('overlay');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', () => {
    closeCartDrawer();
    closeSearchModal();
  });

  // Cart drawer quantity buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.cart-drawer__item-qty .qty-btn');
    if (!btn) return;
    const line = btn.dataset.line;
    const action = btn.dataset.action;
    const span = btn.parentElement.querySelector('span');
    let qty = parseInt(span.textContent);
    if (action === 'increase') qty++;
    if (action === 'decrease') qty = Math.max(0, qty - 1);
    updateCart(line, qty);
  });

  // Cart drawer remove
  document.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('.cart-drawer__item-remove');
    if (!removeBtn) return;
    const line = removeBtn.dataset.line;
    updateCart(line, 0);
  });

  function updateCart(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: quantity })
    })
    .then(res => res.json())
    .then(cart => {
      location.reload();
    })
    .catch(err => console.error('Cart update error:', err));
  }

  /* --- Search Modal --- */
  const searchToggle = document.getElementById('searchToggle');
  const searchModal = document.getElementById('searchModal');
  const searchModalClose = document.getElementById('searchModalClose');

  function openSearchModal() {
    if (searchModal) {
      searchModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      const input = searchModal.querySelector('input');
      if (input) setTimeout(() => input.focus(), 100);
    }
  }

  function closeSearchModal() {
    if (searchModal) {
      searchModal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearchModal);
  if (searchModalClose) searchModalClose.addEventListener('click', closeSearchModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeSearchModal();
    }
  });

  /* --- Product Page --- */
  // Thumbnail gallery
  document.querySelectorAll('.product__thumbnail').forEach(thumb => {
    thumb.addEventListener('click', function() {
      const mainImg = document.getElementById('productImage');
      if (mainImg) {
        mainImg.src = this.dataset.imageUrl;
        mainImg.alt = this.dataset.imageAlt || '';
      }
      document.querySelectorAll('.product__thumbnail').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Variant selection
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const variantsJSON = document.getElementById('productJSON');
    if (variantsJSON) {
      const variants = JSON.parse(variantsJSON.textContent);
      const optionInputs = productForm.querySelectorAll('.product__option-value input');

      optionInputs.forEach(input => {
        input.addEventListener('change', function() {
          // Update active state
          this.closest('.product__option-values').querySelectorAll('.product__option-value').forEach(v => v.classList.remove('active'));
          this.closest('.product__option-value').classList.add('active');

          // Find matching variant
          const selectedOptions = [];
          productForm.querySelectorAll('.product__option').forEach(optionGroup => {
            const checked = optionGroup.querySelector('input:checked');
            if (checked) selectedOptions.push(checked.value);
          });

          const matchedVariant = variants.find(v => {
            return selectedOptions.every((opt, i) => v.options[i] === opt);
          });

          if (matchedVariant) {
            // Update variant ID
            document.getElementById('productVariantId').value = matchedVariant.id;

            // Update URL
            const url = new URL(window.location);
            url.searchParams.set('variant', matchedVariant.id);
            history.replaceState({}, '', url);

            // Update price
            const priceEl = document.getElementById('productPrice');
            if (priceEl) {
              if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                priceEl.innerHTML = '<span class="price price--sale">' + formatMoney(matchedVariant.price) + '</span> <span class="price price--compare">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
              } else {
                priceEl.innerHTML = '<span class="price">' + formatMoney(matchedVariant.price) + '</span>';
              }
            }

            // Update image
            if (matchedVariant.featured_image) {
              const mainImg = document.getElementById('productImage');
              if (mainImg) mainImg.src = matchedVariant.featured_image.src;
            }

            // Update add to cart button
            const addBtn = document.getElementById('addToCart');
            if (addBtn) {
              if (matchedVariant.available) {
                addBtn.disabled = false;
                addBtn.textContent = addBtn.dataset.addText || 'Add to Cart';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = addBtn.dataset.soldText || 'Sold Out';
              }
            }
          }
        });
      });
    }
  }

  // Quantity selector (product page + cart page)
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('input');
    const decrease = selector.querySelector('[data-action="decrease"]');
    const increase = selector.querySelector('[data-action="increase"]');

    if (decrease) {
      decrease.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (increase) {
      increase.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        const max = parseInt(input.max) || 999;
        if (val < max) input.value = val + 1;
      });
    }
  });

  // Add to cart AJAX
  const addToCartForm = document.getElementById('productForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      const data = {};
      formData.forEach((value, key) => data[key] = value);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: data.id, quantity: parseInt(data.quantity) || 1 })
      })
      .then(res => res.json())
      .then(item => {
        openCartDrawer();
        // Update cart count
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const countEl = document.getElementById('cartCount');
            if (countEl) {
              countEl.textContent = cart.item_count;
              countEl.classList.toggle('hidden', cart.item_count === 0);
            }
            // Reload to update drawer content
            location.reload();
          });
      })
      .catch(err => console.error('Add to cart error:', err));
    });
  }

  /* --- Collection Sort --- */
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url.toString();
    });
  }

  /* --- Customer: Login/Recover toggle --- */
  const recoverLink = document.getElementById('recoverLink');
  const cancelRecover = document.getElementById('cancelRecover');
  const recoverForm = document.getElementById('recoverForm');

  if (recoverLink && recoverForm) {
    recoverLink.addEventListener('click', function(e) {
      e.preventDefault();
      recoverForm.style.display = 'block';
      recoverLink.closest('form').style.display = 'none';
    });
  }
  if (cancelRecover && recoverForm) {
    cancelRecover.addEventListener('click', function(e) {
      e.preventDefault();
      recoverForm.style.display = 'none';
      document.querySelector('[data-login-form], form[action*="login"]').style.display = 'block';
    });
  }

  /* --- Mobile Bottom Nav --- */
  const mobileSearchBtn = document.getElementById('mobileSearchBtn');
  const mobileCartBtn = document.getElementById('mobileCartBtn');
  if (mobileSearchBtn) mobileSearchBtn.addEventListener('click', openSearchModal);
  if (mobileCartBtn) mobileCartBtn.addEventListener('click', openCartDrawer);

  /* --- Mobile Sticky Add to Cart --- */
  const stickyATCBtn = document.getElementById('stickyATCBtn');
  if (stickyATCBtn) {
    stickyATCBtn.addEventListener('click', function() {
      const mainForm = document.getElementById('productForm');
      if (mainForm) {
        mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

    // Show/hide sticky ATC based on scroll past main ATC button
    const mainATC = document.getElementById('addToCart');
    const stickyBar = document.getElementById('stickyATC');
    if (mainATC && stickyBar) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyBar.style.transform = 'translateY(100%)';
          } else {
            stickyBar.style.transform = 'translateY(0)';
          }
        });
      }, { threshold: 0 });
      observer.observe(mainATC);
      stickyBar.style.transition = 'transform 0.3s ease';
      stickyBar.style.transform = 'translateY(100%)';
    }
  }

  /* --- Hide/Show Bottom Nav on Scroll --- */
  const bottomNav = document.getElementById('mobileBottomNav');
  if (bottomNav) {
    let lastScrollY = window.scrollY;
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          const currentScroll = window.scrollY;
          if (currentScroll > lastScrollY && currentScroll > 200) {
            bottomNav.style.transform = 'translateY(100%)';
          } else {
            bottomNav.style.transform = 'translateY(0)';
          }
          lastScrollY = currentScroll;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    bottomNav.style.transition = 'transform 0.3s ease';
  }

  /* --- Scroll Animations --- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.section-spacing, .product-card, .collection-list__item, .testimonial').forEach(el => {
      observer.observe(el);
    });
  }

  /* --- Utility: Format Money --- */
  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify ? Shopify.currency.active : 'EUR'
    });
  }

})();
